// export const base_url = `http://localhost:8100`;
export const base_url = `https://api.tomax.exchange`;
